import React from 'react'
import injectStyles from 'react-jss'

const styles = {
  container: {
    border: '1px solid red',
  },
}

const ErrorView = ({ classes, code, message, uri }) =>
  <div className={classes.container}>
    <h2>{code}</h2>
    <p>{message}</p>
    <p>{uri}</p>
  </div>

export default injectStyles(styles)(ErrorView)


// WEBPACK FOOTER //
// ./src/modules/AppErrors/ErrorView.js